import { render, staticRenderFns } from "./AxShortcutFilesystemActions.vue?vue&type=template&id=4a56ed3f&"
import script from "./AxShortcutFilesystemActions.vue?vue&type=script&lang=ts&"
export * from "./AxShortcutFilesystemActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports